// src/pages/Home.jsx
import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="page">
      <section className="hero">
        <div className="hero-content">
          <h1>
            Reliable Roofing & Interior Solutions
            <span className="accent"> for Modern Industries</span>
          </h1>
          <p>
            ROOFTECH delivers high-performance PUF panels, clean rooms, false
            ceilings, raised flooring, and more – engineered for durability,
            safety, and performance.
          </p>
          
        </div>
        <div className="hero-side">
          <div className="hero-card">
            <h3>Solutions We Offer</h3>
            <ul>
              <li>PUF Roofing & Wall Panels</li>
              <li>False Ceilings & Acoustic Systems</li>
              <li>Raised Access Flooring</li>
              <li>Clean Room Construction</li>
              <li>Industrial & Epoxy Flooring</li>
              <li>Safety Barriers & Acoustic Doors</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="grid-section">
        <h2>Core Categories</h2>
        <div className="card-grid">
          <Link to="/puf-panels" className="card">
            <h3>PUF Panels</h3>
            <p>
              Energy-efficient insulated panels for roofs and walls with
              superior thermal performance.
            </p>
          </Link>
          <Link to="/false-ceilings" className="card">
            <h3>False Ceilings</h3>
            <p>
              Clean, modular ceiling systems for offices, plants, and clean
              environments.
            </p>
          </Link>
          <Link to="/raised-flooring" className="card">
            <h3>Raised Flooring</h3>
            <p>
              Access flooring solutions for data centers, offices, and control
              rooms.
            </p>
          </Link>
          <Link to="/clean-rooms" className="card">
            <h3>Clean Rooms</h3>
            <p>
              Turnkey clean room solutions for pharma, food, electronics, and
              healthcare.
            </p>
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Home;
